export default __webpack_public_path__ + "static/media/gaxon.2b3f572a.ttf";